<div class="tabContainer">
  <div class="flex-vertical oui-elevation-04 background-white rounded width-100pc padding-24 gap-16">
    <lib-operation-dashboard-filters
      (onFilterChanged)="onFilterChanged($event)"
      (onFilterInitialized)="onFilterInitialized()"
      [dashboardKey]="dashboardKey"
      [filterSelection]="filterSelection"
      [defaultQueryFilter]="defaultQueryFilter"
      [preSelectedGestionnaireId]="preSelectedGestionnaireId"></lib-operation-dashboard-filters>
    <div class="flex-vertical gap-16 width-100pc">
      <app-operations-table
        [dashboardKey]="dashboardKey"
        [fetchOnInit]="false"
        [receivedData]="requestResult"
        (requestNewPage)="getAllOperations()"
        [(paginationParams)]="paginationParams"
        [columnSelection]="columnSelection"
        (onOperationRowClick)="onRowClick($event)"
        [withSelects]="withSelects"
        [showCheckbox]="showCheckbox"
        [allowedActions]="allowedActions"
        [withCSVExport]="withCSVExport"
        (onSelectionActionClicked)="onSelectionActionClick($event)"
        (onDeleteDraftClicked)="onDeleteDraftClick($event)"
        [selectionActions]="selectionActions"
        (onSortCriteriaUpdate)="onTableSortCriteriaChange($event)"
        (onRefreshRequested)="onRefreshRequested()"
        (onExportClick)="onExportClick()">
      </app-operations-table>
    </div>
  </div>
</div>
